// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__+p1tC"};